import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#f0f7ff",
      d: "M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#006aff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.75 11.603v6.794a.6.6 0 0 1-.309.525l-6.15 3.416a.6.6 0 0 1-.582 0l-6.15-3.416a.6.6 0 0 1-.309-.525v-6.794a.6.6 0 0 1 .309-.524l6.15-3.417a.6.6 0 0 1 .582 0l6.15 3.417a.6.6 0 0 1 .309.524"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#006aff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m8.646 11.47 6.063 3.368a.6.6 0 0 0 .582 0l6.084-3.38M15 21.75V15"
    }, null, -1)
  ]))]))
}
export default { render: render }